import {useAccessToken} from "../../services/auth"
import React, {useEffect, useState} from "react"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useToasts} from "react-toast-notifications"
import {BankSettings, update} from "../../resources/bankSettings"
import Card from "../../containers/Card/Card"
import {toCents, toDollars} from "../../utilities/numbers"

export default function PaymentRules({bankSettings, refresh}: {bankSettings: BankSettings; refresh: () => void}) {
	const accessToken = useAccessToken()
	const [state, patch, reset] = useAsyncResultIdle(update)
	const {addToast} = useToasts()
	const storedThreshold = bankSettings.attributes.checkPaymentVerificationThreshold
	const [thresholdDollars, setThresholdDollars] = useState(storedThreshold == null ? "" : toDollars(storedThreshold))

	useEffect(() => {
		const cents = bankSettings.attributes.checkPaymentVerificationThreshold
		setThresholdDollars(cents == null ? "" : toDollars(cents))
	}, [bankSettings])

	useEffect(() => {
		if (state.isOk()) {
			addToast("Payment Rules Updated Successfully", {appearance: "success"})
			refresh()
			reset()
		}
	}, [state, addToast, refresh, reset])

	return (
		<Card title="Check Payments">
			<form
				onSubmit={(e) => {
					e.preventDefault()
					if (thresholdDollars === "") {
						addToast("Enter an amount", {appearance: "error"})
						return
					}
					patch(
						accessToken,
						{
							checkPaymentVerificationThreshold: Math.round(toCents(thresholdDollars)),
						},
						bankSettings.id
					)
				}}
			>
				<fieldset>
					<div className="field">
						<label className="label">Additional Verification Threshold</label>
						<div className="field has-addons">
							<p className="control">
								<a className="button is-static">$</a>
							</p>
							<div className="control is-expanded">
								<input
									className="input"
									type="number"
									min={0}
									step={0.01}
									value={thresholdDollars}
									onChange={(e) => setThresholdDollars(e.target.value)}
									required
								/>
							</div>
						</div>
					</div>
				</fieldset>
				<div className="columns">
					<div className="column mt-4">
						{state.match(
							() => (
								<button className="button is-success" type="submit">
									Update
								</button>
							),
							() => (
								<button className="button is-success is-loading" type="submit">
									Updating
								</button>
							),
							() => (
								<button className="button is-success" type="submit">
									Update
								</button>
							),
							(err) => (
								<>
									<div className="has-text-danger">{err.errors[0].title}</div>
									<button className="button is-success" type="submit">
										Update
									</button>
								</>
							)
						)}
					</div>
				</div>
			</form>
		</Card>
	)
}
